import { createSelector } from '@reduxjs/toolkit';

import { MaterialListsSliceState } from '../store/materialListsSlice';

export const getLoggedInUsersOrganizationMaterialSet = createSelector(
  (state: MaterialListsSliceState) => state.materialLists,
  (reducerState) => (reducerState && reducerState.state === 'loaded' && reducerState.item) || null,
);
